// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useCallback} from 'react';
import etask from '/util/etask.js';
import {refresh} from '@pub/store/user.js';
import store from '@pub/store.js';
import * as api from '@pub/api.js';
import {Button} from '@pub/comp/button';
import * as cns from './suspension.module.less';

export function Suspension({user}){
    const suspended = !!user?.suspend_reason;
    const handle_user_suspend = useCallback((with_email, with_ips)=>
        etask(function*(){
        const action = suspended ? 'restore' : 'suspend';
        const def_comment = suspended? 'good user' : 'abuse';
        const suspend_reason = yield prompt('Please enter '+action+' comment',
            def_comment);
        if (!suspend_reason)
            return;
        yield api.update_user_status({
            email: user.email,
            action,
            suspend_reason,
            with_email,
            with_ips,
        });
        store.invalidate();
        refresh();
    }), [suspended, user.email]);
    return <div>
      <ul className={cns.actions}>
        {suspended&&<li>
          <Button size="s" on_click={()=>handle_user_suspend()}
            color_scheme="success" filled className={cns.action}>
            Restore user
          </Button>
        </li>}
        {!suspended&&<>
          <li>
            <Button size="s" on_click={()=>handle_user_suspend(false, false)}
              color_scheme="error" filled className={cns.action}>
              Suspend
            </Button>
          </li>
          <li>
            <Button size="s" on_click={()=>handle_user_suspend(true, false)}
              color_scheme="error" filled className={cns.action}>
              Suspend with email
            </Button>
          </li>
          <li>
            <Button size="s" on_click={()=>handle_user_suspend(false, true)}
              color_scheme="error" filled className={cns.action}>
              Suspend with IPS
            </Button>
          </li>
          <li>
            <Button size="s" on_click={()=>handle_user_suspend(true, true)}
              color_scheme="error" filled className={cns.action}>
              Suspend with email and IPs
            </Button>
          </li>
        </>}
      </ul>
    </div>;
}
